"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPaymentContext = exports.isPayment = exports.PaymentSchema = void 0;
const zod_1 = require("zod");
const typing_utils_1 = require("../typing_utils");
const weekly_coaching_types_1 = require("./weekly_coaching_types");
const paymentStatuses = ["pending", "paid", "expired"];
const paymentSources = ["checkout", "one_time_charge"];
const PaymentContextSchema = weekly_coaching_types_1.WeeklyCoachingPaymentContextSchema;
exports.PaymentSchema = zod_1.z.object({
    context: PaymentContextSchema.optional(),
    createdAt: zod_1.z.string(),
    id: zod_1.z.string(),
    referenceId: zod_1.z.string(),
    source: zod_1.z.union(typing_utils_1.mapArrayToLiteralTuple(paymentSources)),
    status: zod_1.z.union(typing_utils_1.mapArrayToLiteralTuple(paymentStatuses)),
    subscriptionId: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
    userId: zod_1.z.string(),
});
const isPayment = (v) => exports.PaymentSchema.safeParse(v).success;
exports.isPayment = isPayment;
const isPaymentContext = (v) => PaymentContextSchema.safeParse(v).success;
exports.isPaymentContext = isPaymentContext;
//# sourceMappingURL=payment_types.js.map